var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1883_230464)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 34,
    height: 34,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5469 16.75C34.547 16.676 34.5372 16.6023 34.5177 16.5309L32.6131 9.86367C32.5008 9.4765 32.2663 9.13602 31.9446 8.89307C31.6229 8.65012 31.2313 8.51772 30.8281 8.51562H11.1719C10.769 8.518 10.3776 8.65054 10.0562 8.89347C9.73476 9.1364 9.50045 9.47671 9.3882 9.86367L7.48367 16.5309C7.46366 16.6022 7.45339 16.6759 7.45313 16.75V18.875C7.45278 19.6811 7.64553 20.4755 8.01524 21.1919C8.38495 21.9082 8.92086 22.5255 9.57813 22.9922V31.625C9.57813 32.1181 9.77402 32.5911 10.1227 32.9398C10.4714 33.2885 10.9444 33.4844 11.4375 33.4844H30.5625C31.0556 33.4844 31.5286 33.2885 31.8773 32.9398C32.226 32.5911 32.4219 32.1181 32.4219 31.625V22.9922C33.0791 22.5255 33.615 21.9082 33.9848 21.1919C34.3545 20.4755 34.5472 19.6811 34.5469 18.875V16.75ZM10.9209 10.302C10.9365 10.2472 10.9694 10.1989 11.0146 10.1642C11.0598 10.1295 11.1149 10.1103 11.1719 10.1094H30.8281C30.8858 10.1095 30.9418 10.1283 30.9878 10.163C31.0338 10.1978 31.0673 10.2465 31.0831 10.302L32.6941 15.9531H9.3125L10.9209 10.302ZM17.5469 17.5469H24.4531V18.875C24.4531 19.7908 24.0893 20.6691 23.4417 21.3167C22.7941 21.9643 21.9158 22.3281 21 22.3281C20.0842 22.3281 19.2059 21.9643 18.5583 21.3167C17.9107 20.6691 17.5469 19.7908 17.5469 18.875V17.5469ZM9.04688 17.5469H15.9531V18.875C15.9531 19.7908 15.5893 20.6691 14.9417 21.3167C14.2941 21.9643 13.4158 22.3281 12.5 22.3281C11.5842 22.3281 10.7059 21.9643 10.0583 21.3167C9.41069 20.6691 9.04688 19.7908 9.04688 18.875V17.5469ZM30.8281 31.625C30.8281 31.6954 30.8001 31.763 30.7503 31.8128C30.7005 31.8626 30.6329 31.8906 30.5625 31.8906H11.4375C11.3671 31.8906 11.2995 31.8626 11.2497 31.8128C11.1999 31.763 11.1719 31.6954 11.1719 31.625V23.7439C12.2097 24.0263 13.3106 23.9697 14.3141 23.5824C15.3175 23.1952 16.171 22.4974 16.75 21.591C17.2054 22.3054 17.8336 22.8934 18.5764 23.3008C19.3193 23.7082 20.1528 23.9217 21 23.9217C21.8472 23.9217 22.6807 23.7082 23.4236 23.3008C24.1664 22.8934 24.7946 22.3054 25.25 21.591C25.829 22.4974 26.6825 23.1952 27.6859 23.5824C28.6894 23.9697 29.7903 24.0263 30.8281 23.7439V31.625ZM29.5 22.3281C28.5842 22.3281 27.7059 21.9643 27.0583 21.3167C26.4107 20.6691 26.0469 19.7908 26.0469 18.875V17.5469H32.9531V18.875C32.9531 19.7908 32.5893 20.6691 31.9417 21.3167C31.2941 21.9643 30.4158 22.3281 29.5 22.3281Z",
    fill: "#F25500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1883_230464",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1883_230464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1883_230464",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/storeIcon.41bef7677f471520036c44c96baeaf6f.svg";
export { ForwardRef as ReactComponent };